export default "__VITE_ASSET__DFuuflUQ__"